import React from 'react';
import Select from 'react-select';

export const MultiSelect = ({
  title,
  empty,
  disabled,
  items,
  onChange,
  className,
  isSearchable,
  isLoading,
  loadingMessage,
  wrapperClassname,
}) => {
  return (
    <div className={wrapperClassname || 'form-column--xs'}>
      {title ? <label>{title}</label> : ''}
      <Select
        maxMenuHeight={10}
        closeMenuOnSelect={false}
        isDisabled={disabled || isLoading}
        isLoading={isLoading}
        isMulti
        isClearable={true}
        isSearchable={isSearchable || false}
        loadingMessage={() => loadingMessage}
        options={items}
        onChange={onChange}
        placeholder={isLoading ? loadingMessage : empty}
        className={className || 'react-multiselect-container'}
        classNamePrefix="react-multiselect"
      />
    </div>
  );
};
